import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { BookedService, NgxToastrService, UtilsService } from '@core/services'
import {
  NgbActiveModal,
  NgbDateParserFormatter,
  NgbModal
} from '@ng-bootstrap/ng-bootstrap'
import { TranslateService } from '@ngx-translate/core'
import moment from 'moment'
import swal from "sweetalert2";
import { Subscription, take } from "rxjs";
import { ExpiredModalComponent } from '@shared/component/expired-modal/expired-modal.component'

@Component({
  selector: 'app-summary-booked',
  templateUrl: './summary-booked.component.html',
  styleUrls: ['./summary-booked.component.scss']
})
export class SummaryBookedComponent implements OnInit, OnDestroy {
  canRequest: boolean
  @Input() userBookingOption
  @Input() hotel
  @Input() totalAdults
  @Input() totalChildrens
  @Input() searchConfig
  @Input() roomsBooked
  @Input() code: string
  @Input() uuidUser: string
  @Input() company
  @Input() isAdmin: boolean
  @Input() selectedRooms;
  @Input() selectedUsers;
  @Input() guests: [] = [];
  @Input() isSummaryRequest: boolean;
  @Input() starAuthRequired: boolean;
  @Input() canOnlyRequestRooms: boolean;
  @Input() isEmployee: boolean;
  form: UntypedFormGroup
  loading: boolean = false
  disabled: boolean = false
  @Output() sendInfo = new EventEmitter<any>()
  @Output() selectedRoomChanged: EventEmitter<any> = new EventEmitter<any>();
  @Input() totalPrice: number
  actualRoom: number
  showPolicies: boolean
  actualGroupRoom: number
  roomsSelected: any[]
  priceChanged = false;
  priceChangeAccepted = false;
  newTotalPrice: number | null = null;
  subscriptions: Subscription[] = [];
  expectedIds = new Set<string>();
  receivedIds = new Set<string>();
  expectedCount = 0;
  private receivedCount = 0;
  flightInfo;
  acceptPackage: boolean = false;
  isPackageRate: string;
  private expiredModalOpen = false;
  private expiredHandledCorrelationIds = new Set<string>();
  priceChangedRooms: Record<string, any> = {};
  unavailableRooms: Record<string, any> = {};
  originalTotalPrice: number = 0;

  constructor (
    private activatedRoute: ActivatedRoute,
    private ngbDateParser: NgbDateParserFormatter,
    private activeModal: NgbActiveModal,
    private formBuilder: UntypedFormBuilder,
    private translate: TranslateService,
    public utilsService: UtilsService,
    private ngxToastrService: NgxToastrService,
    private bookedService: BookedService,
    private modalService: NgbModal
  ) {
      this.utilsService.socket.on("check-rate-booking", (result) => {
        const cid = result?.correlationId;
        const data = result?.data;

        if (!cid) return;

        const selectedRoom = this.selectedRooms?.find(
          (room) => room?.correlationId === cid
        );

        if (!selectedRoom) return;

        this.markReceivedAndMaybeStopLoading(cid);

        const isExpired =
          data?.statusCode === 817 || data?.errorCode === "TOKEN_EXPIRED";

        if (isExpired) {
          this.handleExpired(cid);
          return;
        }
        if((result.data.type && (result.data.type?.toLowerCase().includes("error") || result.data.type?.toLowerCase().includes("exception"))) || (result.data.bookingStatus && (result.data.bookingStatus?.toLowerCase().includes('unknown') || result.data.bookingStatus?.toLowerCase().includes('error')))) {
          if (result?.data?.message.toLowerCase().includes("insufficient allotment")) {
            this.translate
              .get(['hotel.errors.insufficient-allotment'])
              .subscribe(res => {
                this.ngxToastrService.typeInfo(res['hotel.errors.insufficient-allotment'], '')
              })
          } else {
            this.translate
            .get(['hotel.errors.check-rate', 'common.errors.try-again'])
            .subscribe(res => {
              this.ngxToastrService.typeInfo(res['hotel.errors.check-rate'], res['common.errors.try-again'])
            })
          }
          this.activeModal.dismiss()
        } else {
          let roomOriginal: any = {};
          if ((this.code.toString().charAt(0) === "E" && (result.data.status === "Available" || result.data.status === "PriceChanged"))){
            roomOriginal = this.selectedRooms.filter((room) => room.code === result.data.reference && room.rates.find((rate) => rate.rateKey.split("E")[1] === result.data.accommodation.rooms[0].rates[0].rateKey /* && !rate.price */))
          } else if (this.code.toString().charAt(0) !== "E" && (result.data.status === "Available" || result.data.status === "PriceChanged")) {
            roomOriginal = this.selectedRooms.filter((room) => room.code === result.data.reference && room.rates.find((rate) => rate.rateKey === result.data.accommodation.rooms[0].rates[0].rateKey /* && !rate.price */))
          }
          roomOriginal.forEach((room) => {
            const checkedRate =
              result.data?.accommodation?.rooms?.[0]?.rates?.[0];

            if (!checkedRate) {
              return;
            }

            room.rates[0].price = result.data.price;
            room.rates[0].wholesalePrice = result.data.wholesalePrice;

            if (Array.isArray(checkedRate.cancellationPolicies)) {
              room.rates[0].cancellationPolicies =
                checkedRate.cancellationPolicies.map(policy => ({
                  amount: policy.amount,
                  from: policy.from,
                  text: policy.text,
                }));
            }

          });

        if (
          data?.status === "PriceChanged" &&
          data?.errorCode === "PRICE_CHANGED_WITHOUT_NEW_PRICE"
        ) {
          this.handlePriceChangedWithoutNewPrice(data);
          return;
        }

        const isUnavailable =
          data?.status === "SoldOut" ||
          data?.errorCode === "INSUFFICIENT_ALLOTMENT" ||
          data?.errorCode === "STOP_SALES" ||
          data?.message?.toLowerCase?.().includes("insufficient allotment") ||
          data?.message?.toLowerCase?.().includes("stop sales");

        if (isUnavailable) {
          this.handleUnavailableRate(data);
          return;
        }

        const isConnectorError =
          data?.type?.toLowerCase?.().includes("error") ||
          data?.type?.toLowerCase?.().includes("exception") ||
          data?.bookingStatus?.toLowerCase?.().includes("unknown") ||
          data?.bookingStatus?.toLowerCase?.().includes("error");

        if (isConnectorError && data?.status !== "PriceChanged") {
          this.handleUnavailableRate(data);
          return;
        }

        if (data?.status === "PriceChanged" && data?.priceChanged?.currentPrice) {
          this.applyCheckedRateToSelectedRoom(cid, data);
          this.priceChanged = true;
          this.priceChangeAccepted = false;
          this.newTotalPrice = this.getTotalPrice();
          return;
        }

        if (data?.status === "Available") {
          this.applyCheckedRateToSelectedRoom(cid, data);
          this.newTotalPrice = this.getTotalPrice();
          return;
        }
      }});

  }

  ngOnDestroy (): void {
    this.utilsService.socket.off("check-rate-booking");
  }

  ngOnInit () {
    this.isPackageRate = localStorage.getItem("isPackageRate")
    const flight = localStorage.getItem("packageRateFlightInfo");
    if (flight) {
      this.flightInfo = JSON.parse(flight)
    }
    this.canRequest =
      this.activatedRoute.snapshot.queryParams.canRequest === 'true'
        ? true
        : false
    this.form = this.formBuilder.group({
      customCode: [null],
      costCenter: [null],
      travellerReason: [null],
      adminHotelComment: [null],
    })

    this.roomsSelected = [...this.selectedRooms];
    this.originalTotalPrice = this.getTotalPrice();
    this.loading = true;

    let guestOffset = 0;

    this.roomsSelected.forEach((rooms) => {
      const parsedRoom = { ...rooms };

      parsedRoom.nameRoom = rooms.name;
      parsedRoom.net = rooms.rates[0].net;
      parsedRoom.totalWithPercentage = rooms.rates[0].totalWithPercentage;
      parsedRoom.rateType = rooms.rates[0].rateType;
      parsedRoom.rateKey = rooms.rates[0].rateKey;
      parsedRoom.cancellation = !!rooms.rates[0].cancellationPolicies
      parsedRoom.cancellationPolicies = rooms.rates[0].cancellationPolicies
      parsedRoom.cancellationPolicies?.forEach((item, index, array) => {
        array[index] = {
          amount: item.amount,
          from: item.from,
          text: item.text,
        }
      });

      const originalPrice = Number(
        rooms?.rates?.[0]?.totalWithPercentage ??
        rooms?.totalWithPercentage ??
        rooms?.rates?.[0]?.price?.totalPrice?.total ??
        0
      );

      const guestsForRoom = this.guests.slice(
        guestOffset,
        guestOffset + rooms.paxes.length
      );

      guestOffset += rooms.paxes.length;
    
      const body = {
        rooms: [parsedRoom],
        userUuid: this.uuidUser,
        checkIn: `${this.searchConfig.checkIn.year}-${this.searchConfig.checkIn.month}-${this.searchConfig.checkIn.day}`,
        checkOut: `${this.searchConfig.checkOut.year}-${this.searchConfig.checkOut.month}-${this.searchConfig.checkOut.day}`,
        guests: this.sanitizeGuestsForBackend(guestsForRoom),
        accommodationCode: this.hotel.code.slice(1),
        price: originalPrice,
        isAuthorization: false,
      };

      const correlation = crypto.randomUUID();
      this.utilsService.correlationId.push(correlation);

      body['correlationId'] = correlation;
      rooms.correlationId = correlation;

      this.bookedService.checkRate(body).subscribe(() => {
        rooms.correlationId = correlation;
      },
    () => {
        this.markReceivedAndMaybeStopLoading(correlation);
        }
      );
    });
    this.buildExpectedTrackers();
  }

  getTermsOfUseLink(isAgent): string {
    const language = this.translate.currentLang;
    return !isAgent
      ? `https://developer.ean.com/terms/${language}`
      : `https://developer.ean.com/terms/agent/${language === 'es' ? 'es-es' : 'en'}`;
  }

  get f () {
    return this.form.controls
  }

  formatDate (date) {
    return this.ngbDateParser.format(date)
  }

  closeModal () {
    this.activeModal.dismiss('Cross click')
  }

  onSubmit() {
    this.disabled = true;

    if (this.priceChanged && !this.priceChangeAccepted) {
      this.newTotalPrice = this.getTotalPrice();

      const previousPriceTxt = `${Number(this.originalTotalPrice || 0).toFixed(2)}€`;
      const currentPriceTxt = `${Number(this.newTotalPrice || 0).toFixed(2)}€`;

      this.subscriptions.push(
        this.translate.get([
          "flight.detail-flight.price-changed",
          "flight.detail-flight.previous-price",
          "flight.detail-flight.current-price",
          "flight.detail-flight.change-detected",
          "common.confirm",
          "common.cancel",
        ]).subscribe((res) => {
          swal.fire({
            icon: "warning",
            title: res["flight.detail-flight.change-detected"],
            html: `
              <p>${res["flight.detail-flight.price-changed"]}</p>
              <p><strong>${res["flight.detail-flight.previous-price"]}:</strong> ${previousPriceTxt}</p>
              <p><strong>${res["flight.detail-flight.current-price"]}:</strong> ${currentPriceTxt}</p>
            `,
            showCancelButton: true,
            confirmButtonText: res["common.confirm"],
            cancelButtonText: res["common.cancel"],
            reverseButtons: true,
            customClass: {
              popup: "price-change-popup",
              confirmButton: "simple-confirm-btn",
              cancelButton: "simple-cancel-btn",
            },
            buttonsStyling: false,
          }).then((result) => {
            if (result.isConfirmed) {
              this.priceChangeAccepted = true;
              this.emitSubmit();
            } else {
              this.resetPriceChangeState();
              this.closeModal();
            }
          });
        })
      );

      return;
    }

    this.emitSubmit();
  }

  private emitSubmit() {
    const send: any = {
      rooms: this.selectedRooms,
      customCode: this.f.customCode.value ?? '',
      costCenter: this.f.costCenter.value ?? '',
      travellerReason: this.f.travellerReason.value ?? '',
    };

    if (this.priceChanged && this.priceChangeAccepted) {
      send.priceChanged = true;
      send.newTotalPrice = this.newTotalPrice ?? this.getTotalPrice();
    }

    if (this.f.adminHotelComment?.value) {
      send["adminHotelComment"] = this.f.adminHotelComment.value;
    }

    this.sendInfo.emit(send);
  }

  isSameOrAfterToday(date) {
    return date ? moment(date).isSameOrAfter(moment()) : null;
  }

  getTotalPrice() {
    let totalPrice = 0;
    this.selectedRooms.forEach((room) => {
      room.rates.forEach((rate) => {
        totalPrice += rate.price && rate.price.totalPrice ? Number(rate.price.totalPrice.total) : Number(rate.totalWithPercentage);
      })
    })

    if (this.flightInfo) {
      totalPrice += this.flightInfo.totalPrice
    }
    return totalPrice;
  }

  isPackage() {
    return this.selectedRooms.some((room) => room.rates.some((rate) => rate.saleScenario?.package === true))
  }
  private resetPriceChangeState() {
    this.priceChanged = false;
    this.priceChangeAccepted = false;
    this.newTotalPrice = null;
    this.disabled = false;
  }

  private markReceivedAndMaybeStopLoading(id?: string) {
    if ((!this.expectedIds || this.expectedIds.size === 0) && (!this.expectedCount || this.expectedCount === 0)) {
      this.buildExpectedTrackers();
    }

    if (id) {
      const before = this.receivedIds.size;
      this.receivedIds.add(id);
      if (this.receivedIds.size > before) {
        this.receivedCount++;
      }
    } else {
      this.receivedCount++;
    }

    const target = this.expectedIds.size > 0 ? this.expectedIds.size : this.expectedCount;

    if (target > 0 && this.receivedCount >= target) {
      this.loading = false;
    }
  }

  private buildExpectedTrackers() {
    this.receivedIds.clear();
    this.receivedCount = 0;
    this.priceChanged = false;
    this.priceChangeAccepted = false;

    const arr = Array.isArray(this.selectedRooms) ? this.selectedRooms : [];
    if (arr.length === 0) return;

    const ids = arr
      .map((r: any) => r?.correlationId || r?.correlationID || r?.rates?.[0]?.correlationId)
      .filter(Boolean);

    if (ids.length > 0) {
      this.expectedIds = new Set<string>(ids);
      this.expectedCount = this.expectedIds.size;
    } else {
      this.expectedIds = new Set<string>();
      this.expectedCount = arr.length;
    }
  }

  acceptPackageFunc() {
    this.acceptPackage = !this.acceptPackage;
  }

  private handleUnavailableRate(data: any): void {
    const key =
      data?.errorCode === "INSUFFICIENT_ALLOTMENT"
        ? "hotel.errors.insufficient-allotment"
        : data?.errorCode === "STOP_SALES"
        ? "hotel.errors.stop-sales"
        : data?.status === "SoldOut"
        ? "hotel.errors.unavailable"
        : "hotel.errors.check-rate";

    this.translate
      .get([
        key,
        "hotel.errors.unavailable",
        "common.errors.try-again",
      ])
      .pipe(take(1))
      .subscribe((res) => {
        this.ngxToastrService.typeInfo(
          data?.userMessage ||
            data?.message ||
            res[key] ||
            res["hotel.errors.unavailable"],
          res["common.errors.try-again"] || ""
        );
      });

    this.activeModal.dismiss();
  }

  private handlePriceChangedWithoutNewPrice(data: any): void {
    this.translate
      .get([
        "hotel.priceChanged.updated-title",
        "hotel.priceChanged.without-new-price",
        "common.confirm",
      ])
      .pipe(take(1))
      .subscribe((res) => {
        const text =
          data?.userMessage ||
          res["hotel.priceChanged.without-new-price"];

        swal.fire({
          icon: "warning",
          title: res["hotel.priceChanged.updated-title"],
          text,
          showCancelButton: false,
          confirmButtonText: res["common.confirm"],
          customClass: {
            popup: "price-change-popup",
            confirmButton: "simple-confirm-btn",
          },
          buttonsStyling: false,
        }).then(() => {
          this.activeModal.dismiss();
        });
      });
  }

  private handleExpired(cid: string): void {
    if (cid && this.expiredHandledCorrelationIds.has(cid)) return;
    if (cid) this.expiredHandledCorrelationIds.add(cid);

    if (this.expiredModalOpen) return;
    this.expiredModalOpen = true;

    this.activeModal.dismiss();

    const modalRef = this.modalService.open(ExpiredModalComponent, {
      windowClass: "custom-modal-expired",
      centered: true,
      backdrop: "static",
      keyboard: false,
    });

    modalRef.componentInstance.redirectTo = `/search/${this.uuidUser}`;

    modalRef.result.finally(() => {
      this.expiredModalOpen = false;
      this.expiredHandledCorrelationIds.clear();
    });
  }

  private normalizeCheckedRateKey(previousRateKey: string, checkedRateKey: string): string {
    if (!checkedRateKey) return previousRateKey;

    const previousPrefix = previousRateKey?.charAt(0);
    const checkedPrefix = checkedRateKey?.charAt(0);

    const providerPrefixes = ["H", "E"];

    if (
      previousPrefix &&
      providerPrefixes.includes(previousPrefix) &&
      !providerPrefixes.includes(checkedPrefix)
    ) {
      return `${previousPrefix}${checkedRateKey}`;
    }

    return checkedRateKey;
  }

  private applyCheckedRateToSelectedRoom(correlationId: string, data: any): void {
    const roomIndex = this.selectedRooms.findIndex(
      (room: any) => room?.correlationId === correlationId
    );

    if (roomIndex === -1) return;

    const selectedRoom = this.selectedRooms[roomIndex];

    const checkedRoom =
      data?.checkedRoom ||
      data?.accommodation?.rooms?.[0];

    const checkedRate =
      data?.checkedRate ||
      checkedRoom?.rates?.[0] ||
      data?.accommodation?.rooms?.[0]?.rates?.[0];

    if (!checkedRate) return;

    const previousPaxes = selectedRoom?.paxes || [];
    const previousRoomName = selectedRoom?.name;
    const previousRoomCode = selectedRoom?.code;
    const previousRate = selectedRoom?.rates?.[0] || {};

    const currentPrice = Number(
      data?.priceChanged?.currentPrice ??
      data?.price?.totalPrice?.total ??
      checkedRate?.totalWithPercentage ??
      checkedRate?.net ??
      0
    );

    const mergedRate = {
      ...previousRate,
      ...checkedRate,
      rateKey: this.normalizeCheckedRateKey(
        previousRate?.rateKey,
        checkedRate?.rateKey
      ),
      price: data?.price || checkedRate?.price || previousRate?.price,
      wholesalePrice:
        checkedRate?.wholesalePrice ??
        data?.price?.wholesalePrice?.amount ??
        previousRate?.wholesalePrice,
      totalWithPercentage: currentPrice
        ? currentPrice.toFixed(2)
        : checkedRate?.totalWithPercentage || previousRate?.totalWithPercentage,
    };

    const checkedRoomWithoutInternalFields = { ...(checkedRoom || {}) };

    delete checkedRoomWithoutInternalFields.userBookingOption;
    delete checkedRoomWithoutInternalFields.priceChanged;
    delete checkedRoomWithoutInternalFields.checkedRoom;
    delete checkedRoomWithoutInternalFields.priceCheck;

    this.selectedRooms[roomIndex] = {
      ...selectedRoom,
      ...checkedRoomWithoutInternalFields,
      code: previousRoomCode || checkedRoom?.code,
      name: previousRoomName || checkedRoom?.name,
      paxes: checkedRoom?.paxes || previousPaxes,
      correlationId,
      rates: [mergedRate],
    };

    this.roomsSelected = [...this.selectedRooms];

    this.selectedRoomChanged.emit(this.selectedRooms[roomIndex]);
  }
  private sanitizeGuestsForBackend(guests: any[]): any[] {
    return (guests || []).map((guest) => ({
      name: guest?.name || '',
      surname: guest?.surname || guest?.lastname || '',
    }));
  }
  
}
